import ApplicationLayout from '../../components/layouts/ApplicationLayout';
import { useFetcher } from '../../hooks/useFetcher';
import { getUserList, deleteUser } from '../../api/cms/user';
import { LoadingBox } from '../../components/LoadingBox';
import useSWR from 'swr';
import { makeStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  Paper,
  Typography,
  FormControlLabel,
  Switch,
  Box,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AddIcon from '@material-ui/icons/Add';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { updatePlatformById } from '../../api/cms/platform';
import Breadcrumbs from 'components/Breadcrumbs';
import CreateUserModal from 'components/admin/user/CreateUserModal';

const UserList = () => {
  const [platformActive, setPlatformActive] = useState(false);
  const [platformId, setPlatformId] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState(null);

  const { data, error, mutate } = useSWR(
    ['getUserList', platformActive, platformId, page, rowsPerPage],
    () => getUserList({ page: page + 1, limit: rowsPerPage }),
  );
  if (error) toast.error('error');

  const onActiveChange = (is_active, id) => {
    console.log('isactive : ', is_active);
    console.log('id : ', id);
    console.log('platformId : ', platformId);

    updatePlatformById(id, { is_active })
      .then(() => {
        setPlatformId(id);
        setPlatformActive(is_active);
        toast.success('updated');
      })
      .catch((error) => {
        toast.error('can not updated');
      });
  };

  const handleDeleteClick = (id, username) => {
    setSelectedUserName(username);
    setSelectedId(id);
    setConfirmDeleteOpen(true);
  };

  const handleConfirmDeleteClose = () => {
    setConfirmDeleteOpen(false);
    setSelectedId(null);
  };

  const handleConfirmDelete = () => {
    if (selectedId) {
      deleteUser(selectedId)
        .then(() => {
          toast.success('deleted');
          mutate();
        })
        .catch((error) => {
          toast.error(error.response?.data?.message);
        })
        .finally(() => {
          handleConfirmDeleteClose();
        });
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // reset to first page
  };

  return (
    <ApplicationLayout>
      {!data ? (
        <LoadingBox />
      ) : (
        <>
          <Breadcrumbs />
          <Typography variant="h6" gutterBottom component="div">
            User List
          </Typography>
          <CreateUserModal onSubmitSuccess={() => mutate()} />
          <TableContainer component={Paper} style={{ marginBottom: 50 }}>
            <Table aria-label="user table">
              <TableHead>
                <TableRow>
                  <TableCell>Username</TableCell>
                  <TableCell>Phone Number</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.users.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {row.username}
                    </TableCell>
                    <TableCell>{row.phone_number}</TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={row.is_active}
                            onChange={(event) => {
                              // setPlatformId(row.user_id);
                              onActiveChange(event.target.checked, row.user_id);
                            }}
                          />
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        <Link to={`/admin/user_list/${row.user_id}`}>
                          <Button variant="contained" color="secondary">
                            <ExitToAppIcon />
                          </Button>
                        </Link>
                        <Button
                          variant="contained"
                          style={{ backgroundColor: '#DB2D40', color: 'white' }}
                          onClick={() => handleDeleteClick(row.user_id, row.username)}
                        >
                          <DeleteForeverIcon />
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              count={data.total || 0}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[10, 50, 100]}
            />
          </TableContainer>
          <Dialog open={confirmDeleteOpen} onClose={handleConfirmDeleteClose}>
            <DialogTitle>
              <Box display="flex" alignItems="center" gap={1}>
                <DeleteForeverIcon color="error" />
                Confirm Delete
              </Box>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <DialogContentText>Are you sure to delete {selectedUserName}?</DialogContentText>
              <DialogContentText>
                Press the "CONTINUE" button to confirm the{' '}
                <Typography component="span" color="error">
                  deletion
                </Typography>{' '}
                or
              </DialogContentText>
              <DialogContentText>press the "CANCEL" button to cancel.</DialogContentText>
            </DialogContent>
            <Divider />
            <DialogActions
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '16px',
              }}
            >
              <Button
                onClick={handleConfirmDelete}
                variant="contained"
                style={{ backgroundColor: '#d32f2f', color: 'white' }}
              >
                Continue
              </Button>

              <Button
                onClick={handleConfirmDeleteClose}
                variant="outlined"
                style={{ borderColor: 'black', color: 'black' }}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </ApplicationLayout>
  );
};

export default UserList;
